import { Component, Input } from '@angular/core';

@Component({
    selector: 'page-preloader',
    styles: [`
        .page-preloader {
            position: fixed;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 18;
            background-color: rgba(0,0,0,0.7);
        }
    `],
    template: `
        <div class="page-preloader animated {{effect}}" [class.hidden]="hidden">
            <div class="layout-column layout-align-center-center h-100">
                <div class="flex-nogrow text-center">
                    <bw-preloader color="red"></bw-preloader>
                    <div>{{message}}</div>
                </div>
            </div>
        </div>
    `
})
export class PagePreloaderComponent {
    @Input() message = 'Loading ...';

    effect = 'fadeIn';
    hidden = false;

    show() {
        this.hidden = false;
        this.effect = 'fadeIn';
    }

    hide() {
        this.effect = 'fadeOut';
        setTimeout(() => this.hidden = true, 1200);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/page-preloader/page-preloader.component.ts